import React, { useState, useEffect } from "react";
import { Form, Input, Button, Card, message, Select, Upload } from "antd";
import { UploadOutlined, CloseCircleFilled } from "@ant-design/icons";
import axios from "axios";
import { API_BASE } from "../../config/api";
import { getAuthHeaders } from "../../utils/auth";

const CreateService = ({onSuccess}) => {
  const [loading, setLoading] = useState(false);
  const [subCategories, setSubCategories] = useState([]);
  const [preview, setPreview] = useState(null);
  const [file, setFile] = useState(null);
  const [form] = Form.useForm();

  // 🔹 Traer subcategorías al cargar
  useEffect(() => {
    const fetchSubCats = async () => {
      try {
        const { data } = await axios.get(`${API_BASE}/subcategory`);
        setSubCategories(data);
      } catch (error) {
        message.error("Error cargando subcategorías");
      }
    };
    fetchSubCats();
  }, []);

  // 🔹 Crear servicio
  const onFinish = async (values) => {
    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("description", values.description);
      formData.append("price", values.price);
      formData.append("subCategoryId", values.subCategoryId);
      formData.append("promotion", values.promotion);
      formData.append("combinable", String(values.combinable ?? false));
      formData.append("duration", values.duration);



      if (file) formData.append("image", file);

      await axios.post(`${API_BASE}/services`, formData, {
        headers: getAuthHeaders({ "Content-Type": "multipart/form-data" }),
      });

      message.success("Servicio creado correctamente");
      form.resetFields();
      setPreview(null);
      setFile(null);
      onSuccess();
    } catch (err) {
      console.error(err);
      message.error("Error creando servicio");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card  style={{ maxWidth: 600, margin: "auto" }}>
      <Form layout="vertical" form={form} onFinish={onFinish}>

        {/* Nombre */}
        <Form.Item label="Nombre" name="name" rules={[{ required: true }]}>
          <Input placeholder="Ej: Corte de Cabello" />
        </Form.Item>
  
        {/* Descripción */}
        <Form.Item label="Descripción" name="description">
          <Input.TextArea rows={3} placeholder="Ej: servicio clásico..." />
        </Form.Item>
   {/* Promoción */}
        <Form.Item 
          label="Promoción" 
          name="promotion" 
          rules={[{ required: false }]}
        >
          <Input type="number" min={0} />
        </Form.Item>
        {/* Precio */}
        <Form.Item 
          label="Precio" 
          name="price" 
          rules={[{ required: true }]}
        >
          <Input type="number" min={0} />
        </Form.Item>

        <Form.Item
          label="Duración (minutos)"
          name="duration"
          initialValue={15}
          rules={[{ required: true, message: "Ingrese la duración del servicio" }]}
        >
          <Input type="number" min={15} step={15} />
        </Form.Item>

        <Form.Item
          label="Combinable"
          name="combinable"
          initialValue={false}
          rules={[{ required: true, message: "Seleccione si el servicio se puede combinar" }]}
        >
          <Select
            options={[
              { value: true, label: "true" },
              { value: false, label: "false" },
            ]}
          />
        </Form.Item>

        {/* SubCategoría */}
        <Form.Item
          label="Subcategoría"
          name="subCategoryId"
          rules={[{ required: true, message: "Seleccione una subcategoría" }]}
        >
          <Select placeholder="Seleccione una subcategoría">
            {subCategories.map((sc) => (
              <Select.Option key={sc.id} value={sc.id}>
                {sc.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        {/* Imagen */}
       {/*  <Form.Item label="Imagen del servicio">
          <Upload
            beforeUpload={(file) => {
              setFile(file);
              setPreview(URL.createObjectURL(file));
              return false;
            }}
            maxCount={1}
            showUploadList={false}
          >
            <Button icon={<UploadOutlined />}>Seleccionar imagen</Button>
          </Upload>

          {preview && (
            <div style={{ marginTop: 15, position: "relative", width: 120 }}>
              <img
                src={preview}
                alt="preview"
                style={{
                  width: 120,
                  height: 120,
                  objectFit: "cover",
                  borderRadius: 6,
                  border: "1px solid #ddd",
                }}
              />
              <CloseCircleFilled
                onClick={() => {
                  setPreview(null);
                  setFile(null);
                }}
                style={{
                  position: "absolute",
                  top: -10,
                  right: -10,
                  fontSize: 20,
                  color: "red",
                  cursor: "pointer",
                }}
              />
            </div>
          )}
        </Form.Item> */}

        {/* Botón */}
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            Crear Servicio
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default CreateService;
